import VueCookie from 'vue-cookie'
import {
  authMac,
  decomposeUrl
} from '@packages/utils'

let authorization = ({
  url,
  method,
  macId,
  macKey
}) => {
  let urlDecomposion = decomposeUrl(url)
  return authMac({
    macId,
    macKey,
    httpMethod: method,
    requestURI: urlDecomposion.uri,
    host: urlDecomposion.host
  })
}

let isDomain = (function () {
  return !/^\d+$/.test(location.hostname.replace(/\./g, ''))
}())

// hmac 认证
// https://coding.net/u/chenzuopeng/p/wm-uc/git
export default {
  options: {
    MAC_ID: '2YotnFZFEjr1zCsicMWpAA',
    MAC_KEY: 'mac_key',
    SESSION_ID: 'session_id',
    decode: true,
    getMacKey() {
      let macKey = VueCookie.get(this.MAC_KEY) || ''
      return this.decode ? decodeURIComponent(macKey) : macKey
    },
    getSessionId() {
      let sessionId = VueCookie.get(this.SESSION_ID) || ''
      return this.decode ? decodeURIComponent(sessionId) : sessionId
    }
  },
  install(requestInterceptor, responseInterceptor, opts = {}) {

    opts = Object.assign({}, this.options, opts)

    requestInterceptor.use(config => {
      // mac = false 接口不做hmac认证
      if (config.mac !== false && config.headers.Authorization == null) {
        if (!isDomain && console && console.log) {
          console.log('Cookie is used in non-domain, confirm that in your expectation.')
        }
        Object.assign(config.headers, {
          Authorization: authorization(Object.assign({
            macId: opts.MAC_ID,
            macKey: opts.getMacKey()
          }, config)),
          [opts.SESSION_ID]: opts.getSessionId()
        })
      }
      return config
    })
  }
}



// WEBPACK FOOTER //
// ./src/packages/plugins/src/axios/src/interceptor/src/authMac.js